import { metricsServerApi } from '../../modules/servers'
import { setMetricsServerState } from './slice'

export const msApi = metricsServerApi.injectEndpoints({
  endpoints: (builder) => ({
    setOnlineModeStatus: builder.mutation<boolean, boolean>({
      query: (isOnline) => ({
        url: 'api/config/online',
        method: 'POST',
        body: { isOnline }
      }),
      invalidatesTags: ['offlineModeStatus']
    }),

    getOnlineModeStatus: builder.query<boolean, void>({
      query: () => ({
        url: 'api/config/online',
        method: 'GET'
      }),
      providesTags: ['offlineModeStatus']
    }),

    getSeatConfiguration: builder.query<any, void>({
      query: () => ({
        url: 'service/seatConfiguration',
        method: 'GET'
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled
          dispatch(
            setMetricsServerState({
              seatConfiguration: data
            })
          )
        } catch (err) {
          console.error('Error fetching seat configuration:', err)
        }
      }
    })
  }),
  overrideExisting: true
})

export const {
  useSetOnlineModeStatusMutation,
  useGetOnlineModeStatusQuery,
  useLazyGetSeatConfigurationQuery
} = msApi
